module.exports = __webpack_public_path__ + "static/pic14-a65f818e32bcf7448b31f02c6b8013c3.png";